"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7985],{

/***/ 11566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_AudioPlayer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(87952);
// EXTERNAL MODULE: ./node_modules/plyr/dist/plyr.min.js
var plyr_min = __webpack_require__(21443);
var plyr_min_default = /*#__PURE__*/__webpack_require__.n(plyr_min);
// EXTERNAL MODULE: ./node_modules/plyr/dist/plyr.css
var plyr = __webpack_require__(5667);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./src/utils/axios.js
var axios = __webpack_require__(92369);
;// CONCATENATED MODULE: ./src/service/gplx.speech.service.js




var synthesizeTextToSpeech = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(text, gender) {
        var config, resp, audioBlob;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    config = {
                        url: "/texttospeech/synthesize",
                        method: "POST",
                        data: {
                            text: text,
                            gender: gender
                        },
                        responseType: "arraybuffer"
                    };
                    return [
                        4,
                        (0,axios/* handleRequest */.X)(config)
                    ];
                case 1:
                    resp = _state.sent();
                    if ((0,_instanceof/* default */.Z)(resp, ArrayBuffer)) {
                        audioBlob = new Blob([
                            resp
                        ], {
                            type: "audio/mp3"
                        });
                        return [
                            2,
                            URL.createObjectURL(audioBlob)
                        ];
                    }
                    return [
                        2,
                        null
                    ];
            }
        });
    });
    return function synthesizeTextToSpeech(text, gender) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/AudioPlayer.js
/* eslint-disable react/prop-types */ 







var AudioPlayer = function(param) {
    var text = param.text, _index = param.index, index = _index === void 0 ? "" : _index;
    var ref = (0,react.useState)("male"), voiceName = ref[0], setVoiceName = ref[1];
    var playerRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var player = new (plyr_min_default())("#player-".concat(index), {
            speed: {
                selected: 1,
                options: [
                    0.25,
                    0.5,
                    1,
                    1.25,
                    1.5
                ]
            }
        });
        playerRef.current = player;
        player.on("play", function() {
            if (!player.source) fetchAudio(voiceName);
        });
        return function() {
            player.destroy();
        };
    }, [
        text,
        index
    ]);
    var fetchAudio = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(voiceName) {
            var audioUrl;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            synthesizeTextToSpeech(text, voiceName)
                        ];
                    case 1:
                        audioUrl = _state.sent();
                        if (audioUrl) {
                            playerRef.current.source = {
                                type: "audio",
                                sources: [
                                    {
                                        src: audioUrl,
                                        type: "audio/mp3"
                                    }
                                ]
                            };
                            playerRef.current.play();
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchAudio(voiceName) {
            return _ref.apply(this, arguments);
        };
    }();
    var changeVoice = function(name) {
        if (name !== voiceName) {
            setVoiceName(name);
            fetchAudio(name);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
            item: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                spacing: 2,
                my: 1,
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        alt: "male",
                        src: "/img/male.jpg",
                        onClick: function() {
                            return changeVoice("male");
                        },
                        sx: {
                            border: voiceName === "male" ? "2px solid blue" : "none",
                            cursor: "pointer",
                            width: 30,
                            height: 30
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        alt: "female",
                        src: "/img/female.jpg",
                        onClick: function() {
                            return changeVoice("female");
                        },
                        sx: {
                            border: voiceName === "female" ? "2px solid blue" : "none",
                            width: 30,
                            height: 30,
                            cursor: "pointer"
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("audio", {
                        id: "player-".concat(index),
                        className: "plyr",
                        controls: true,
                        children: "Your browser does not support the audio element."
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_AudioPlayer = (AudioPlayer);


/***/ }),

/***/ 41449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CartImage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_Card__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66242);
/* harmony import */ var _mui_material_CardMedia__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83965);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _LightboxModal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74055);
/* eslint-disable react/prop-types */ 




function CartImage(param) {
    var item = param.item;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), openLightbox = ref[0], setOpenLightbox = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Card__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                raised: true,
                sx: {
                    maxWidth: "100%",
                    margin: "0 auto",
                    padding: "0.1em"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardMedia__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    component: "img",
                    height: "250",
                    image: "/img/".concat(item === null || item === void 0 ? void 0 : item.i, ".png"),
                    alt: "alt",
                    title: "titleasdasdsada",
                    sx: {
                        padding: "1em 1em 0 1em",
                        objectFit: "contain"
                    },
                    onClick: function() {
                        return setOpenLightbox(true);
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LightboxModal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                images: [
                    "/img/".concat(item === null || item === void 0 ? void 0 : item.i, ".png")
                ],
                mainSrc: "/img/".concat(item === null || item === void 0 ? void 0 : item.i, ".png"),
                photoIndex: 0,
                setPhotoIndex: 0,
                isOpen: openLightbox,
                onCloseRequest: function() {
                    return setOpenLightbox(false);
                }
            })
        ]
    });
}


/***/ }),

/***/ 28075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ GoogleBannerAds; },
/* harmony export */   "a": function() { return /* binding */ GoogleGridAds; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function GoogleBannerAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "1281160371",
        "data-ad-format": "auto",
        "data-full-width-responsive": "true"
    });
}
function GoogleGridAds() {
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        try {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (err) {
            console.log(err);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ins", {
        className: "adsbygoogle",
        style: {
            display: "block"
        },
        "data-ad-format": "autorelaxed",
        "data-ad-client": "ca-pub-2522844423315072",
        "data-ad-slot": "6470023398"
    });
}


/***/ }),

/***/ 991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HeaderBreadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/lodash/isString.js
var isString = __webpack_require__(47037);
var isString_default = /*#__PURE__*/__webpack_require__.n(isString);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 1 modules
var Link = __webpack_require__(50122);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@mui/material/Breadcrumbs/Breadcrumbs.js + 3 modules
var Breadcrumbs = __webpack_require__(12963);
;// CONCATENATED MODULE: ./src/components/Breadcrumbs.js





// next

// @mui

// ----------------------------------------------------------------------
Breadcrumbs_Breadcrumbs.propTypes = {
    activeLast: (prop_types_default()).bool,
    links: (prop_types_default()).array.isRequired
};
function Breadcrumbs_Breadcrumbs(_param) {
    var links = _param.links, _activeLast = _param.activeLast, activeLast = _activeLast === void 0 ? false : _activeLast, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "activeLast"
    ]);
    var currentLink = links[links.length - 1].name;
    var listDefault = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
            link: link
        }, link.name);
    });
    var listActiveLast = links.map(function(link) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            style: {
                marginBottom: 5
            },
            children: link.name !== currentLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkItem, {
                link: link
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                sx: {
                    maxWidth: 260,
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    color: "text.disabled",
                    textOverflow: "ellipsis"
                },
                textTransform: "inherit",
                children: currentLink
            })
        }, link.name);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            component: "span",
            sx: {
                width: 4,
                height: 4,
                borderRadius: "50%",
                bgcolor: "text.disabled"
            }
        }),
        style: {
            alignItems: "center"
        }
    }, other), {
        children: activeLast ? listDefault : listActiveLast
    }));
}
// ----------------------------------------------------------------------
LinkItem.propTypes = {
    link: prop_types_default().shape({
        href: (prop_types_default()).string,
        icon: (prop_types_default()).any,
        name: (prop_types_default()).string
    })
};
function LinkItem(param) {
    var link = param.link;
    var _href = link.href, href = _href === void 0 ? "" : _href, name = link.name, icon = link.icon;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
            variant: "body2",
            sx: {
                lineHeight: 2,
                display: "flex",
                alignItems: "center",
                color: "grey.600",
                "& > div": {
                    display: "inherit"
                }
            },
            textTransform: "inherit",
            children: [
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        mr: 1,
                        "& svg": {
                            width: 20,
                            height: 20
                        }
                    },
                    children: icon
                }),
                name
            ]
        }, name)
    });
}

// EXTERNAL MODULE: ./src/components/Iconify.js
var Iconify = __webpack_require__(22554);
;// CONCATENATED MODULE: ./src/components/HeaderBreadcrumbs.js





// @mui

//



// ----------------------------------------------------------------------
HeaderBreadcrumbs.propTypes = {
    links: (prop_types_default()).array,
    subtitle: (prop_types_default()).node,
    heading: (prop_types_default()).string.isRequired,
    moreLink: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array
    ]),
    sx: (prop_types_default()).object
};
function HeaderBreadcrumbs(_param) {
    var links = _param.links, subtitle = _param.subtitle, heading = _param.heading, _moreLink = _param.moreLink, moreLink = _moreLink === void 0 ?  false || [] : _moreLink, sx = _param.sx, other = (0,_object_without_properties/* default */.Z)(_param, [
        "links",
        "subtitle",
        "heading",
        "moreLink",
        "sx"
    ]);
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: (0,_object_spread/* default */.Z)({}, sx),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                spacing: 1,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs_Breadcrumbs, (0,_object_spread/* default */.Z)({
                        links: links
                    }, other)),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: {
                                    justifyContent: "flex-start"
                                },
                                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Iconify/* default */.Z, {
                                    icon: "fa-solid:arrow-left"
                                }),
                                onClick: function() {
                                    return router.back();
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "h5",
                                component: "h1",
                                textTransform: "uppercase",
                                children: heading
                            })
                        ]
                    }),
                    subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexShrink: 0,
                            pl: 8
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body1",
                            children: subtitle
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2
                },
                children: isString_default()(moreLink) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: moreLink,
                    target: "_blank",
                    variant: "body2",
                    children: moreLink
                }) : moreLink.map(function(href) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        noWrap: true,
                        href: href,
                        variant: "body2",
                        target: "_blank",
                        sx: {
                            display: "table"
                        },
                        children: href
                    }, href);
                })
            })
        ]
    });
}


/***/ }),

/***/ 74055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LightboxModal; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_image_lightbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92879);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42287);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41796);






// @mui


// ----------------------------------------------------------------------
function LightboxModalStyles() {
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var isRTL = theme.direction === "rtl";
    var ICON_SIZE = 32;
    var ICON_COLOR = theme.palette.grey[600].replace("#", "");
    var getIcon = function(icon) {
        return "url(https://api.iconify.design/carbon/".concat(icon, ".svg?color=%23").concat(ICON_COLOR, "&width=").concat(ICON_SIZE, "&height=").concat(ICON_SIZE, ")");
    };
    var Icon = function(icon) {
        return {
            opacity: 1,
            alignItems: "center",
            display: "inline-flex",
            justifyContent: "center",
            backgroundImage: "unset",
            backgroundColor: "transparent",
            transition: theme.transitions.create("opacity"),
            "&:before": {
                display: "block",
                width: ICON_SIZE,
                height: ICON_SIZE,
                content: getIcon(icon)
            },
            "&:hover": {
                opacity: 0.72
            }
        };
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        styles: {
            "& .ReactModalPortal": {
                "& .ril__outer": {
                    backgroundColor: (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_5__/* .alpha */ .Fq)(theme.palette.grey[900], 0.96)
                },
                // Toolbar
                "& .ril__toolbar": {
                    height: "auto !important",
                    padding: theme.spacing(2, 3),
                    backgroundColor: "transparent"
                },
                "& .ril__toolbarLeftSide": {
                    display: "none"
                },
                "& .ril__toolbarRightSide": {
                    height: "auto !important",
                    padding: 0,
                    flexGrow: 1,
                    display: "flex",
                    alignItems: "center",
                    "& li": {
                        display: "flex",
                        alignItems: "center"
                    },
                    "& li:first-of-type": {
                        flexGrow: 1
                    },
                    "& li:not(:first-of-type)": {
                        width: 40,
                        height: 40,
                        justifyContent: "center",
                        marginLeft: theme.spacing(2)
                    }
                },
                // Button
                "& button:focus": {
                    outline: "none"
                },
                "& .ril__toolbarRightSide button": {
                    width: "100%",
                    height: "100%",
                    "&.ril__zoomInButton": Icon("zoom-in"),
                    "&.ril__zoomOutButton": Icon("zoom-out"),
                    "&.ril__closeButton": Icon("close")
                },
                "& .ril__navButtons": {
                    padding: theme.spacing(3),
                    "&.ril__navButtonPrev": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        right: "auto",
                        left: theme.spacing(2)
                    }, Icon(isRTL ? "arrow-right" : "arrow-left")),
                    "&.ril__navButtonNext": (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        left: "auto",
                        right: theme.spacing(2)
                    }, Icon(isRTL ? "arrow-left" : "arrow-right"))
                }
            }
        }
    });
}
// ----------------------------------------------------------------------
LightboxModal.propTypes = {
    images: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().array.isRequired),
    photoIndex: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().number),
    setPhotoIndex: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().func),
    isOpen: (prop_types__WEBPACK_IMPORTED_MODULE_7___default().bool)
};
function LightboxModal(_param) {
    var images = _param.images, photoIndex = _param.photoIndex, setPhotoIndex = _param.setPhotoIndex, isOpen = _param.isOpen, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "images",
        "photoIndex",
        "setPhotoIndex",
        "isOpen"
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "unset";
        }
    }, [
        isOpen
    ]);
    var showIndex = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        variant: "subtitle2",
        children: "".concat(photoIndex + 1, " / ").concat(images.length)
    });
    var toolbarButtons = [
        showIndex
    ];
    var customStyles = {
        overlay: {
            zIndex: 9999
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LightboxModalStyles, {}),
            isOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_image_lightbox__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                animationDuration: 160,
                nextSrc: images[(photoIndex + 1) % images.length],
                prevSrc: images[(photoIndex + images.length - 1) % images.length],
                onMovePrevRequest: function() {
                    return setPhotoIndex((photoIndex + images.length - 1) % images.length);
                },
                onMoveNextRequest: function() {
                    return setPhotoIndex((photoIndex + 1) % images.length);
                },
                toolbarButtons: toolbarButtons,
                reactModalStyle: customStyles
            }, other))
        ]
    });
}


/***/ }),

/***/ 28961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67720);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83321);
/* harmony import */ var _mui_material_FormControl__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(94054);
/* harmony import */ var _mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50480);
/* harmony import */ var _mui_material_Radio__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(49033);
/* harmony import */ var _mui_material_RadioGroup__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(68061);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_AudioPlayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11566);
/* harmony import */ var _components_CartImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41449);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40571);
/* eslint-disable react/prop-types */ "use client";










function Question(param) {
    var item = param.item, index = param.index;
    var ref;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var themeMode = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().themeMode;
    var isLight = themeMode === "light";
    var statusStyle = function(answer) {
        if (check) {
            if (item.a === answer) {
                return isLight ? theme.palette.success.light : theme.palette.success.dark;
            }
            if (item.a !== answer && indexA === answer) {
                return isLight ? theme.palette.error.light : theme.palette.error.dark;
            }
        }
    };
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), indexA = ref2[0], setIndex = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), check = ref3[0], setCheck = ref3[1];
    var handleChange = function(event) {
        setValue(event.target.value);
        setIndex(parseInt(event.target.value));
    };
    var handleShow = function() {
        setCheck(true);
    };
    var text = item.q + " " + ((ref = item.c) === null || ref === void 0 ? void 0 : ref.map(function(answer, index) {
        return "".concat(index + 1, ". ").concat(answer);
    }).join(" "));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        bgcolor: isLight ? "#fcfaf6" : theme.palette.background.neutral,
        spacing: 2,
        pt: 2,
        my: 2,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                spacing: 1,
                px: 3,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_AudioPlayer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        text: text,
                        index: index + 1
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        variant: "body1",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("strong", {
                                children: [
                                    "C\xe2u ",
                                    index + 1,
                                    ":"
                                ]
                            }),
                            " ",
                            item.q
                        ]
                    }),
                    item.i !== "" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CartImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        item: item
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControl__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_RadioGroup__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    value: value,
                    onChange: handleChange,
                    children: [
                        1,
                        2,
                        3,
                        4
                    ].map(function(answer) {
                        return item.c[answer - 1] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_FormControlLabel__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            value: answer,
                            control: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Radio__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}),
                            sx: {
                                backgroundColor: statusStyle(answer),
                                py: 1,
                                m: 0,
                                px: 2
                            },
                            label: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                variant: "body1",
                                children: [
                                    answer,
                                    ". ",
                                    item.c[answer - 1]
                                ]
                            })
                        }, answer);
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                px: 3,
                bgcolor: isLight ? theme.palette.warning.light : theme.palette.background.neutral,
                children: [
                    check && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        my: 1,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                children: "Giải th\xedch:"
                            }),
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                dangerouslySetInnerHTML: {
                                    __html: item.e
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        variant: "text",
                        color: "error",
                        sx: {
                            p: 0
                        },
                        size: "large",
                        onClick: handleShow,
                        children: "Gợi \xfd đ\xe1p \xe1n"
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Question);


/***/ }),

/***/ 51753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ checkLicense; }
/* harmony export */ });
function checkLicense(str) {
    if (str.toUpperCase() === "A1") {
        return 0;
    } else if (str.toUpperCase() === "A2") {
        return 1;
    } else if (str.toUpperCase() === "A3") {
        return 2;
    } else if (str.toUpperCase() === "A4") {
        return 3;
    } else if (str.toUpperCase() === "B1") {
        return 4;
    } else if (str.toUpperCase() === "B2") {
        return 5;
    } else if (str.toUpperCase() === "C") {
        return 6;
    } else if (str.toUpperCase() === "D") {
        return 7;
    } else if (str.toUpperCase() === "E") {
        return 8;
    } else if (str.toUpperCase() === "F") {
        return 9;
    }
}


/***/ }),

/***/ 50168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ licenseDataArray; }
/* harmony export */ });
// exam
var b1 = Array.from(Array(20).keys());
var b2 = Array.from(Array(18).keys());
var c = Array.from(Array(15).keys());
var d = Array.from(Array(14).keys());
var e = Array.from(Array(14).keys());
var f = Array.from(Array(14).keys());
var a1 = Array.from(Array(8).keys());
var a2 = Array.from(Array(18).keys());
var a3 = Array.from(Array(20).keys());
var a4 = Array.from(Array(20).keys());
// chapter
var chapterB1 = Array.from(Array(9).keys());
var chapterB2 = Array.from(Array(9).keys());
var chapterC = Array.from(Array(9).keys());
var chapterD = Array.from(Array(9).keys());
var chapterE = Array.from(Array(9).keys());
var chapterF = Array.from(Array(9).keys());
var chapterA1 = Array.from(Array(7).keys());
var chapterA2 = Array.from(Array(8).keys());
var chapterA3 = Array.from(Array(7).keys());
var chapterA4 = Array.from(Array(8).keys());
// examRandom
var b1Random = Array.from(Array(20).keys());
var b2Random = Array.from(Array(18).keys());
var cRandom = Array.from(Array(15).keys());
var dRandom = Array.from(Array(14).keys());
var eRandom = Array.from(Array(14).keys());
var fRandom = Array.from(Array(14).keys());
var a1Random = Array.from(Array(8).keys());
var a2Random = Array.from(Array(18).keys());
var a3Random = Array.from(Array(20).keys());
var a4Random = Array.from(Array(20).keys());
var licenseDataArray = [
    [
        a1,
        a2,
        a3,
        a4,
        b1,
        b2,
        c,
        d,
        e,
        f
    ],
    [
        chapterA1,
        chapterA2,
        chapterA3,
        chapterA4,
        chapterB1,
        chapterB2,
        chapterC,
        chapterD,
        chapterE,
        chapterF
    ],
    [
        a1Random,
        a2Random,
        a3Random,
        a4Random,
        b1Random,
        b2Random,
        cRandom,
        dRandom,
        eRandom,
        fRandom
    ],
    [
        "a1",
        "a2",
        "a3",
        "a4",
        "b1",
        "b2",
        "c",
        "d",
        "e",
        "f"
    ],
    [
        "o-to",
        "xe-may"
    ]
];


/***/ })

}]);